<template>
  <div class="rofix-card" v-bind="$attrs">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "RofixCard",
};
</script>

<style>
.rofix-card {
  border: 1px solid #d9d9d9;
}
</style>
